module.exports = "<div class=\"column-chart\">\n    <div class=\"x-axis\">\n\n    </div>\n    <div class=\"y-axis\">\n\n    </div>\n    <div class=\"plot-area\">\n\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/column-chart/column-chart.component.html
// module id = ../../../../../src/app/components/column-chart/column-chart.component.html
// module chunks = main